/* eslint-disable no-nested-ternary */
import { withTheme } from 'styled-components';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { ThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { WidgetSizeConsumer } from '../../contexts/WidgetSize';
import MaterialButton from '../../atoms/MaterialButton';
import AmountField from '../../molecules/AmountField/AmountField';
import deepDefaultProps from '../../util/deepDefaultProps';
import {
  buildTargetUrl, mapPurposeToCafePurpose, purposeOptions, termOptions,
} from '../../util/formHelper';
import { MUITheme } from '../../util/ThemeHoc/theme';
import { SmallForm, MediumForm, LargeForm, SmallH2, MediumH2, LargeH2, PaddingBox, SmallWrapper, MediumWrapper, LargeWrapper } from './MaterialLoanForm.style';

/**
 * Prefix for all keys within the WebStorage
 */
export const STORAGE_KEY_PREFIX = 'ffg-lead-';
export const STORAGE_KEY_RESUME_HASH = STORAGE_KEY_PREFIX + 'resumeHash';

class MaterialLoanForm extends React.PureComponent {

  static propTypes = {
    minAmount: PropTypes.number,
    maxAmount: PropTypes.number,
    affiliateData: PropTypes.object.isRequired,
    theme: PropTypes.shape({ bodyShadow: PropTypes.bool.isRequired }).isRequired,
  };

  static defaultProps = {
    minAmount: 1000,
    maxAmount: 100000,
  };

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.smallBreakPoint = 504;
    this.mediumBreakPoint = 740;
    this.largeBreakPoint = 976;

    if (!this.props.theme.bodyShadow) {
      this.smallBreakPoint = this.smallBreakPoint - 16;
      this.mediumBreakPoint = this.mediumBreakPoint - 16;
      this.largeBreakPoint = this.largeBreakPoint - 16;
    }

    const {
      affiliateData: {
        amount,
        term,
        purpose,
      },
    } = this.props;

    this.state = {
      amount,
      term,
      purpose,
    };
  }

  handleAmountChange = (event, value) => {
    const { maxAmount, minAmount } = this.props;

    if (value >= minAmount && value <= maxAmount) {
      this.setState({
        amount: value,
      });
    }
  };

  handleTermChange = (event) => {
    const { value } = event.target;
    const options = termOptions.filter(item => item.value === value);

    if (options.length) {
      this.setState({
        term: value,
      });
    }
  };

  handlePurposeChange = (event) => {
    const { value } = event.target;
    const options = purposeOptions.filter(item => item.value === value);

    if (options.length) {
      this.setState({
        purpose: value,
      });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const form = event.target;
    if (!form.checkValidity()) return;

    const {
      affiliateData: {
        targetUrl, parameters, submitMode, subId,
      },
    } = this.props;
    const { amount, term, purpose } = this.state;


    const url = buildTargetUrl(targetUrl, {
      ...parameters,
      amount,
      purpose: mapPurposeToCafePurpose(purpose),
      subId,
      term,
    });
    switch (submitMode) {
      default:
      case 'REDIRECT':
        window.location.href = url;
        break;
      case 'WINDOW':
        window.open(url, '_blank');
        break;
      case 'AMP':
        window.open(url, '_top');
        break;
    }
  };

  render() {
    const {
      minAmount,
      maxAmount,
      affiliateData: {
        headlineText,
        buttonText,
      },
    } = this.props;

    const {
      amount,
      term,
      purpose,
    } = this.state;

    return (
      <ThemeProvider theme={MUITheme}>
        <WidgetSizeConsumer>
          {({ width: widgetWidth }) => {
            const small = widgetWidth < this.smallBreakPoint;
            const medium = widgetWidth > this.smallBreakPoint && widgetWidth < this.mediumBreakPoint;
            const large = widgetWidth >= this.mediumBreakPoint;
            const Wrapper = small ? SmallWrapper : medium ? MediumWrapper : LargeWrapper;
            const Form = small ? SmallForm : medium ? MediumForm : LargeForm;
            const H2 = small ? SmallH2 : medium ? MediumH2 : LargeH2;
            return (
              <PaddingBox>
                <Form method="post" onSubmit={this.handleSubmit}>
                  <H2>{headlineText || 'Jetzt günstige Kredite finden'}</H2>
                  <Wrapper>
                    <div>
                      <AmountField
                        name="amount"
                        lookAndFeel="Material"
                        label="Nettodarlehensbetrag"
                        onChange={this.handleAmountChange}
                        placeholder="10.000"
                        value={amount}
                        min={minAmount}
                        max={maxAmount}
                        unit="EURO"
                        required
                        noErrorMessage
                        autoComplete="off"
                      />
                    </div>
                    <div>
                      <FormControl variant="filled">
                        <InputLabel id="termLabel">Laufzeit</InputLabel>
                        <Select
                          name="term"
                          labelId="termLabel"
                          native
                          value={term.toString()}
                          onChange={this.handleTermChange}
                        >
                          {termOptions.map(option => <option value={option.value}>{option.label}</option>)}

                        </Select>
                      </FormControl>
                    </div>
                    <div>
                      <FormControl variant="filled">
                        <InputLabel id="purposeLabel">Verwendungszweck</InputLabel>
                        <Select
                          name="purpose"
                          labelId="purposeLabel"
                          native
                          value={purpose}
                          onChange={this.handlePurposeChange}
                        >
                          {purposeOptions.map(option => <option value={option.value}>{option.label}</option>)}
                        </Select>
                      </FormControl>
                    </div>
                    {!large && (
                      <div>
                        <MaterialButton type="submit" label={buttonText} subLabel={small ? '(kostenlos & unverbindlich)' : undefined} />
                      </div>
                    )}
                  </Wrapper>
                  {large &&
                    (
                      <div style={{ padding: '8px' }}>
                        <MaterialButton type="submit" label={buttonText} subLabel="(kostenlos & unverbindlich)" />
                      </div>
                    )
                  }
                </Form>
              </PaddingBox>
            );
          }}
        </WidgetSizeConsumer>

      </ThemeProvider>
    );
  }

}

export default withTheme(deepDefaultProps({
  affiliateData: {
    buttonText: 'Zum Kreditvergleich',
    targetUrl: 'https://www.finanzcheck.de/kreditantrag/',
    amount: 10000,
    term: 84,
    purpose: 'OTHER',
    layout: '',
  },
})(MaterialLoanForm));
